import { accessRole } from "../../../../../helpers/access_role"
import { config } from "../../../../../helpers/config_global"
import React, { useState, Component, Fragment } from "react"
import { Redirect } from "react-router-dom"

import { 
    Label,
    Row, Col,
    Button,
    Tooltip,
    Modal, 
    ModalBody, 
    ModalFooter, 
    ModalHeader
 } from "reactstrap"
 import Select from '../../../../../helpers/ui/CustomSelect'
 import { AvForm, AvField, } from "availity-reactstrap-validation"
import MKIDatatable from '../../../../../modules/mki-datatable/lib'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'

import { cancelToken } from "../../../../../services/adapters/kepegawaian/menuService"
import apiResponse from '../../../../../services/apiResponse'

import DataTableBloc from "../Blocs/DraftBloc"
import IndexBloc from'../../Index/Blocs/IndexBloc'
import LoadingComponent from './LoadingComponent'

class TableComponent extends Component {
    dataTableBloc = new DataTableBloc();
    indexBloc = new IndexBloc();

    source
    historyTable = 'historyWorkUnitTableDraft' // Nama di tiap tabel harus beda karena akan disimpan di session
    defaultOrder = 'hirarki' // orderBy
    defaultSize = 10
    defaultSort = 'asc'
    configDatatable = {
        ...config('datatable'),
        sort: {
            column: this.defaultOrder,
            order: this.defaultSort
        }
    }

    constructor(props) {
        super(props)
        this.state = {
            tooltip: false,
            detailUuid: null,
            updateUuid: null,
            inactiveUuid: null,
            defaultSize: 10,
            detail: null,
            rows: [],
            totalRow: 0,
            loadingTable: true,
            eselon: [],
            bknServiceOrganisasi: [],
            selectFilter: 
                    {
                        filter_value: "",
                        page_number: 1,
                        page_size: this.defaultSize,
                        sort_order: {
                            column: this.defaultOrder,
                            order: this.defaultSort
                        }
                    },
            filter: 
                    {
                        filter_value: "",
                        page_number: 1,
                        page_size: this.defaultSize,
                        sort_order: {
                            column: this.defaultOrder,
                            order: this.defaultSort
                        }
                    }
            }
    }

    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    loadDetail = async (uuid) => {
        await this.indexBloc.fetchDetailDraft({ uuid: uuid }, this.source.token)    
    }

    loadData = async () => {
        /* history Datatable */
        sessionStorage.setItem(this.historyTable, JSON.stringify(this.state.filter))

        /* kirim ke server */
        let offset = (this.state.filter.page_number-1)*this.state.filter.page_size
        if(this.state.defaultSize!==this.state.filter.page_size) {
            this.setState({
                defaultSize: this.state.filter.page_size
            })
            offset = 0
            this.configDatatable.page_number = 1
        }
        const query = {
            search: this.state.filter.filter_value,
            limit: this.state.filter.page_size,
            offset: offset,
            order: this.state.filter.sort_order.column,
            sort: this.state.filter.sort_order.order,
            status: 1
        }
        await this.dataTableBloc.fetchRowTable(query, this.source.token)
    }

    toggleModal = () => this.setState({ updateUuid: null, detailUuid: null })
    toggleTooltip = () => this.setState({ tooltip: !this.state.tooltip });

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.state.updateUuid,
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                if (this.state.updateUuid !== null) {
                    this.submitData()
                } else {
                    this.inactiveData()
                }
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    inactiveData = async () => {
        await this.dataTableBloc.fetchInactive({ id: this.state.inactiveUuid })
    }

    submitData = async () => {
        await this.indexBloc.fetchUpdateDraft(this.state.dataForm)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadList()
        this.loadData()
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)
            
        this.state.selectFilter.filter_value = value
            
        this.timer = setTimeout(() => this.loadList(), 800)
    }

    loadEselon = async (uuid) => {
        await this.indexBloc.fetchEselonDraft({ uuid: uuid })
    }

    loadList = async () => {
        const { selectFilter } = this.state
        let offset = (this.state.selectFilter.page_number-1)*this.state.selectFilter.page_size
        const query = {
            search: selectFilter.filter_value,
            limit: selectFilter.page_size,
            offset: offset,
            order: selectFilter.sort_order.column,
            sort: selectFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchSelect(query, this.source.token)
    }

    componentDidMount() {
        this.setTokenAPI()
        this.indexBloc.bknServiceOrganisasi()
        this.indexBloc.bknServiceOrganisasiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if (result.data.status) {
                        let response = result.data.response
                        this.setState({
                            bknServiceOrganisasi: response,
                        })
                        this.setState({ loadingTable: false })

                    }
                    break
                case apiResponse.ERROR:

                    break
                default:
                    break
            }
        })
        this.dataTableBloc.rowtableChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.INITIAL:
                    this.setState({
                        loadingTable: false
                    })
                    break
                case apiResponse.LOADING:
                    this.setState({
                        loadingTable: true
                    })
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        totalRow: response.total,
                        rows: response.result,
                        loadingTable: false
                    })
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.indexBloc.eselonChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    // console.log(response)
                    this.setState({
                        eselon: result.data.response
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        
                    });
                    break
                default:
                    break
            }
        })

 
        this.indexBloc.selectChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ list: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.dataTableBloc.inactiveChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        loadingTable: true,
                        message: "Data berhasil dihapus",
                    }, function () {
                        this.toggleModal()
                        this.setTokenAPI()
                        this.props.handleInactiveSuccess()
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                        message: "Data gagal dihapus",
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.eselonChannelDraft.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        eselon: result.data.response
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        
                    });
                    break
                default:
                    break
            }
        })

        this.indexBloc.detailChannelDraft.subscribe((result) => {
            switch (result.status) {
                case apiResponse.LOADING:
                    this.setState({
                        loadingDetail: true
                    });
                    break
                case apiResponse.COMPLETED:
                    const response = result.data.response
                    this.setState({
                        loadingDetail: false,
                        detail: response
                    });
                    // console.log(response)
                    this.loadEselon(response.work_unit_uuid)
                    break
                case apiResponse.ERROR:
                    this.setState({
                        
                    });
                    break
                default:
                    break
            }
        })


        this.indexBloc.updateChannelDraft.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                        message: "Data berhasil diubah",
                    });
                    this.toggleModal()
                    this.props.handleInactiveSuccess()
                    // this.props.loadDraft()
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                        message: "Data gagal diubah",
                    });
                    this.toggleModal()
                    this.props.handleInactiveSuccess()
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.dataTableBloc.rowtableChannel?.unsubscribe()
        this.dataTableBloc.detailChannelDraft?.unsubscribe()
    }

    columns = [
        {
            key: "work_unit_name",
            text: "Nama Unit",
            sortable: false,
        },
        {
            key: "work_unit_parent_name",
            text: "Parent Unit",
            sortable: false,
        },
        {
            key: "work_unit_echelon_name",
            text: "Eselon",
            sortable: false,
        },
        {
            key: "work_unit_bup",
            text: "BUP",
            sortable: false,
        },
        {
            key: "work_unit_job_grade",
            text: "Grade",
            sortable: false,
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            width: 120,
            sortable: false,
            align: 'center',
            cell: record => {
                const thisId = record.work_unit_id
                return (
                    <Fragment>
                        <span>
                            <button
                                className="btn btn-primary btn-sm"
                                id={"detail-"+thisId}
                                onClick={() => {
                                    this.setState({
                                        detailUuid: record.work_unit_uuid
                                    })
                                    this.loadDetail(record.work_unit_uuid)
                                }}
                                style={{ marginRight: '2px', padding: '2px 5px' }}
                            >
                                <i className="uil-align-left"></i>
                            </button>
                            <Tooltip
                                style={{ marginBottom: '2px' }}
                                placement="top" isOpen={this.state["detail"+thisId]} target={"detail-"+thisId}
                                toggle={() => {
                                    this.setState({
                                        ["detail"+thisId] : !this.state["detail"+thisId]
                                    })
                                }}
                            >
                                Detail
                            </Tooltip>
                        </span>
                        { accessRole('update') && 
                            <span>
                                <button
                                    className="btn btn-warning btn-sm"
                                    id={"update-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            updateUuid: record.work_unit_uuid
                                        })
                                        this.loadDetail(record.work_unit_uuid)
                                    }}
                                    style={{
                                        marginRight: '2px',
                                        padding: '2px 5px'
                                    }}>
                                        <i className="uil-pen"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["update" + thisId]} target={"update-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["update" + thisId] : !this.state["update" + thisId]
                                        })
                                    }}
                                >Perbaharui</Tooltip>
                            </span> 
                        }
                        { accessRole('delete') &&
                            <span>
                                 <button 
                                    className="btn btn-danger btn-sm" 
                                    id={"delete-" + thisId}
                                    onClick={() => {
                                        this.setState({
                                            inactiveUuid: record.work_unit_uuid,
                                            confirm: true
                                        })
                                    }}
                                    style={{
                                        padding: '2px 5px'
                                    }}>
                                    <i className="uil-trash-alt"></i>
                                </button>
                                <Tooltip
                                    style={{
                                        marginBottom: 2
                                    }}
                                    placement="top" isOpen={this.state["delete" + thisId]} target={"delete-" + thisId}
                                    toggle={() => {
                                        this.setState({
                                            ["delete" + thisId] : !this.state["delete" + thisId]
                                        })
                                    }}
                                >Nonaktifkan</Tooltip>                           
                            </span>
                        }
                    </Fragment>
                )
            }
        }
    ]

    render() {
        // console.log(this.state.eselon)
        return (
            <>
                <MKIDatatable
                    className={this.configDatatable.tableClass}
                    config={this.configDatatable}
                    records={this.state.rows}
                    columns={this.columns}
                    dynamic={true}
                    minWidth={1000}
                    total_record={this.state.totalRow}
                    initial={this.state.filter}
                    onChange={(filter) => {
                        this.setState({
                            loadingTable: true,
                            filter: filter
                        }, function () {
                            this.setTokenAPI()
                        });
                    }}
                    loading={this.state.loadingTable}
                />

<Modal
                    size="lg"
                    isOpen={this.state.updateUuid !== null ? true : this.state.detailUuid !== null ? true : false}
                    toggle={() => this.toggleModal()}
                >
                    <ModalHeader 
                        toggle={() => this.toggleModal()}
                    >
                        Edit Satuan/Unit Baru
                    </ModalHeader>
                    <AvForm
                        className="needs-validation"
                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                    >
                        <ModalBody>
                            { this.state.loadingDetail == true ? 
                                <Fragment>
                                    <LoadingComponent message="Memeriksa Data Satuan Unit..." />
                                </Fragment>         
                                : 
                                <Fragment>
                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-4 col-form-label"
                                        >
                                            Nama Satuan/Unit <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="8">
                                            <AvField
                                                name="work_unit_name"
                                                placeholder="Nama Struktur Organisasi"
                                                errorMessage="Masukkan Struktur Organisasi"
                                                type="text"
                                                className="form-control"
                                                value={this.state.detail?.work_unit_name}
                                                disabled={this.state.detailUuid != null ? true : false}
                                                validate={{ required: { value: true } }}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-4 col-form-label"
                                        >
                                            Parent
                                        </Label>
                                        <Col md="8">
                                            { this.state.detailUuid != null ?
                                                <AvField
                                                    name="work_unit_parent_name_"
                                                    placeholder="Nama Struktur Organisasi"
                                                    errorMessage="Masukkan Struktur Organisasi"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.detail.parent?.work_unit_name}
                                                    disabled={this.state.detailUuid != null ? true : false}
                                                    validate={{ required: { value: true } }}
                                                />
                                                :
                                                <Select 
                                                    name="work_unit_parent_uuid"
                                                    errorMessage="Pilih Parent Struktur Organisasi"
                                                    options={this.state.list} 
                                                    optionLabel="work_unit_name"
                                                    optionValue="work_unit_uuid"
                                                    defaultValue={this.state.detail?.work_unit_parent_uuid}
                                                    isClearable
                                                    placeholder="Pilih Parent (Kosongkan jika ingin dijadikan parent)"
                                                    // onInputChange={this.handleSelectInputChange}
                                                    onChange={opt => this.loadEselon(opt?.work_unit_uuid)}
                                                />
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-4 col-form-label"
                                        >
                                            Eselon <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="8">

                                            { this.state.detailUuid != null ?
                                                <AvField
                                                    name="work_unit_parent_name"
                                                    placeholder="Nama Struktur Organisasi"
                                                    errorMessage="Masukkan Struktur Organisasi"
                                                    type="text"
                                                    className="form-control"
                                                    value={this.state.eselon?.find((item)=>item?.echelon_uuid === this.state.detail?.work_unit_echelon_uuid)?.echelon_name}
                                                    disabled={this.state.detailUuid != null ? true : false}
                                                    validate={{ required: { value: true } }}
                                                />
                                                :
                                                <Select 
                                                    name="work_unit_echelon_uuid"
                                                    errorMessage="Pilih Eselon"
                                                    options={this.state.eselon} 
                                                    optionLabel="echelon_name"
                                                    defaultValue={''+this.state.detail?.work_unit_echelon_uuid}
                                                    optionValue="echelon_uuid"
                                                    placeholder="Pilih Eselon"
                                                    validate={{ required: { value: true } }}
                                                />
                                            }
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-4 col-form-label"
                                        >
                                            Batas Usia Pensiun <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="8">
                                            <AvField
                                                name="work_unit_bup"
                                                placeholder="Batas Usia Pensiun"
                                                errorMessage="Masukkan Batas Usia Pensiun"
                                                type="text"
                                                className="form-control"
                                                disabled={this.state.detailUuid != null ? true : false}
                                                validate={{ required: { value: true } }}
                                                value={this.state.detail?.work_unit_bup}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-4 col-form-label"
                                        >
                                            Grade <span className="text-danger">*</span>
                                        </Label>
                                        <Col md="8">
                                            <AvField
                                                name="work_unit_job_grade"
                                                placeholder="grade"
                                                errorMessage="Masukkan Grade"
                                                type="text"
                                                disabled={this.state.detailUuid != null ? true : false}
                                                className="form-control"
                                                validate={{ required: { value: true } }}
                                                value={this.state.detail?.work_unit_job_grade}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mb-3">
                                        <Label
                                            className="col-md-4 col-form-label"
                                        >
                                            Urutan Struktur Organisasi
                                        </Label>
                                        <Col md="4">
                                            <AvField
                                                name="work_unit_sort"
                                                placeholder="Urutan Struktur Organisasi"
                                                errorMessage="Masukkan Urutan Struktur Organisasi"
                                                type="number"
                                                className="form-control"
                                                disabled={this.state.detailUuid != null ? true : false}
                                                value={this.state.detail?.work_unit_sort}
                                            />
                                        </Col>
                                    </Row>

                                </Fragment>
                            }
                        </ModalBody>
                        { this.state.updateUuid !== null &&
                            <ModalFooter>
                                <Button
                                    color="primary"
                                    type="submit"
                                >
                                    Submit
                                </Button>
                                {' '}
                                <Button 
                                    onClick={() => this.toggleModal()}
                                >
                                    Cancel
                                </Button>
                            </ModalFooter>
                        }
                    </AvForm>
                </Modal>

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo={ this.state.updateUuid != null ? "Apakah anda yakin akan mengubah data ini?" : "Apakah anda yakin akan menghapus data ini?" }

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo={this.state.message}

                    failedTitle="Gagal!"
                    failedInfo={this.state.message}

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
            </>
        )
    }
}

export default TableComponent